import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f9e1bac0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f9e1bac0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e1bac0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\qianduan\\residents-move\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9e1bac0')) {
      api.createRecord('f9e1bac0', component.options)
    } else {
      api.reload('f9e1bac0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f9e1bac0&scoped=true", function () {
      api.rerender('f9e1bac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/douyin_review_failed/index.vue"
export default component.exports